
export const defaultSortKey = 'id';

// Define the Invoice type
export interface MultiInvoiceSort {
  InvoiceNo: string;
  WebOrderId: string;
  InvoiceDate: number;
  InvoiceDueDate: number;
  InvoiceTotal: number;
}

// Define the Query type
export interface MultiInvoiceQuery {
  q: string;
  first: number;
  offset: number;
  orderBy: string; // e.g., "InvoiceNo" or "-InvoiceNo"
  createdBy: string;
  email: string;
}

export const sortIdArr: { [key: string]: string } = {
  id: 'InvoiceNo',
  orderNumber: 'WebOrderId',
  createdAt: 'InvoiceDate',
  updatedAt: 'InvoiceDueDate',
  originalBalance: 'InvoiceTotal',
  openBalance: 'openBalanceAmount',
  status: 'status',
};

export interface InvoiceList {
  ARDivisionNo: string,
  CustomerNo: string,
  InvoiceNo: string,
  SalesOrderNo: string,
  WebOrderId: string,
  InvoiceDate: number,
  InvoiceDueDate: number,
  OrderDate: number,
  InvoiceTotal: number,
  TrackingNumbers: string[],
  PDF: string
}

export interface InvoiceListNode {
  node: InvoiceList;
}
